export const isValidMacedonianNumber = (number) => {
    const macedonianRegex = /^3897\d{7}$/;
    return macedonianRegex.test(number);
  }